import { ContentfulNextJsImage } from '@components/common/ContentfulImage'
import { IImage } from '@utils/contentful/contentfulImage'
import { ContentfulMarkdown } from '@utils/contentful/ContentfulMarkdown'
import { useEffect, useState } from 'react'
import { useProductOption } from '../../BriefingFormDataProvider'

const DEFAULT_CARD_IMAGE_BACKGROUND = '#f3f3f3'

interface IBriefSliderCard {
  label: string
  description: string
  image: IImage
  className: string
  selected: boolean
  onSelection: () => void
  alternativeImage?: IImage
  alternativeModeToggleOption?: string
  alternativeModeToggleOptionValue?: string
}

export function BriefSliderCard({
  label,
  description,
  image,
  className,
  selected,
  onSelection,
  alternativeImage = null,
  alternativeModeToggleOption = null,
  alternativeModeToggleOptionValue = null,
}: IBriefSliderCard) {
  const productOption = useProductOption()

  const [displayAlternativeImage, setDispalyAlternativeImage] =
    useState<boolean>(false)

  useEffect(() => {
    if (alternativeImage?.imageUrl) {
      if (
        Object.prototype.hasOwnProperty.call(
          productOption,
          alternativeModeToggleOption
        ) &&
        productOption[alternativeModeToggleOption]
          ?.toString()
          ?.toLowerCase() === alternativeModeToggleOptionValue
      ) {
        setDispalyAlternativeImage(true)
      } else {
        setDispalyAlternativeImage(false)
      }
    }
  }, [
    alternativeImage,
    alternativeModeToggleOption,
    alternativeModeToggleOptionValue,
  ])

  return (
    <div
      className={`flex flex-col border-2  w-[250px] min-w-[250px] rounded-lg overflow-hidden cursor-pointer ${className} ${
        selected
          ? 'border-black-20 bg-black-10'
          : 'border-black-10 bg-core-white'
      }`}
      onClick={onSelection}
    >
      {image?.imageUrl && (
        <ContentfulNextJsImage
          backgroundColour={DEFAULT_CARD_IMAGE_BACKGROUND}
          alt={
            displayAlternativeImage
              ? alternativeImage?.imageTitle
              : image?.imageTitle
          }
          src={
            displayAlternativeImage
              ? alternativeImage?.imageUrl
              : image?.imageUrl
          }
          objectFit="cover"
          className="w-full"
          width={250}
          height={196}
          quality={60}
          format="jpg"
        />
      )}

      <div
        className={`flex flex-col p-6 bg-core-white ${
          selected ? 'bg-black-10' : 'bg-core-white'
        }`}
      >
        <h3 className="mb-2 text-2xl font-bold text-acai">{label}</h3>
        <ContentfulMarkdown
          overrideClass={`text-lg leading-6 ${
            selected ? 'text-acai' : 'text-acai-80'
          }`}
        >
          {description}
        </ContentfulMarkdown>
      </div>
    </div>
  )
}
